// Action Types
export const FETCH_HERO_CARDS_REQUEST = 'xlinkonline/office/FETCH_HERO_CARDS_REQUEST';
export const FETCH_HERO_CARDS_SUCCESS = 'xlinkonline/office/FETCH_HERO_CARDS_SUCCESS';
export const FETCH_HERO_CARDS_FAILURE = 'xlinkonline/office/FETCH_HERO_CARDS_FAILURE';
// Collected Fees
export const FETCH_FEES_CARDS_REQUEST = 'xlinkonline/office/FETCH_FEES_CARDS_REQUEST';
export const FETCH_FEES_CARDS_SUCCESS = 'xlinkonline/office/FETCH_FEES_CARDS_SUCCESS';
export const FETCH_FEES_CARDS_FAILURE = 'xlinkonline/office/FETCH_FEES_CARDS_FAILURE';

// Initial State
const initialState = {
  heroCards: {
    loading: false,
    data: {},
    error: null,
  },
  feesCards: {
    loading: false,
    data: {},
    error: null,
  },
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_HERO_CARDS_REQUEST:
      return {
        ...state,
        heroCards: {
          ...state.heroCards,
          loading: true,
          error: null,
        },
      };

    case FETCH_HERO_CARDS_SUCCESS:
      return {
        ...state,
        heroCards: {
          ...state.heroCards,
          loading: false,
          data: action.payload,
        },
      };

    case FETCH_HERO_CARDS_FAILURE:
      return {
        ...state,
        heroCards: {
          ...state.heroCards,
          loading: false,
          error: action.payload,
        },
      };

    case FETCH_FEES_CARDS_REQUEST:
      return {
        ...state,
        feesCards: {
          ...state.feesCards,
          loading: true,
          error: null,
        },
      };

    case FETCH_FEES_CARDS_SUCCESS:
      return {
        ...state,
        feesCards: {
          ...state.feesCards,
          loading: false,
          data: action.payload,
        },
      };
    case FETCH_FEES_CARDS_FAILURE:
      return {
        ...state,
        feesCards: {
          ...state.feesCards,
          loading: false,
          error: action.payload,
        },
      };

    default:
      return state;
  }
}

// Actions
export const actions = {
  fetchHeroCards: payload => ({
    type: FETCH_HERO_CARDS_REQUEST,
    payload,
  }),

  fetchHeroCardsSuccess: payload => ({
    type: FETCH_HERO_CARDS_SUCCESS,
    payload,
  }),

  fetchHeroCardsFailure: payload => ({
    type: FETCH_HERO_CARDS_FAILURE,
    payload,
  }),

  fetchFeesCards: payload => ({
    type: FETCH_FEES_CARDS_REQUEST,
    payload,
  }),

  fetchFeesCardsSuccess: payload => ({
    type: FETCH_FEES_CARDS_SUCCESS,
    payload,
  }),

  fetchFeesCardsFailure: payload => ({
    type: FETCH_FEES_CARDS_FAILURE,
    payload,
  }),
};
